import {AfterViewInit, Component, Input} from '@angular/core';
import {Compbaser} from "../compbaser";
import {LocalStoreService} from "../../services";
import {IAccessTable} from "../../interfaces";
import {AccessService} from "../../services";

@Component({
    selector: 'app-theme-selector',
    styleUrls: ['./theme-selector.component.scss'],
    templateUrl: './theme-selector.component.html'
})
export class ThemeSelectorComponent extends Compbaser implements AfterViewInit {
    theme = 0;
    accessConfig: IAccessTable;

    @Input() hideUI = false;
    @Input() hideText = false;

    constructor(private localStoreService: LocalStoreService, private accessService: AccessService) {
        super();
        this.cod(
            this.accessService.getGroupsTable('Global', "global_settings").subscribe((v) => {
                this.accessConfig = v;
            })
        );
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.theme = this.localStoreService.getStorageValConfig('theme');
        });
    }

    onThemeChanged(e) {
        if (!this.accessConfig?.upd) return this.accessService.showNoAccess();
        this.localStoreService.setStorageValConfig('theme', e.value);
    }
}
